<template>
  <div
    class="column has-text-centered opportunity-item"
    :style="{ color: otherIsActive ? 'black' : '#d1d1d1' }"
  >
    <b-icon
      icon="bolt"
      :style="{ color: otherIsActive ? 'black' : '#d1d1d1' }"
    ></b-icon>
    <br />

    <span>Outros</span>
  </div>
</template>

<script>
export default {
  props: ["otherIsActive"]
};
</script>

<style scoped>
div {
  font-size: 1rem;
}
</style>
